<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "./assets/css/style";
#app {
  width:100%;
  height:100%;
  overflow-x: scroll;

}
</style>



// WEBPACK FOOTER //
// src/App.vue